@if (label()) {
  <p
    class="m-0 text-lg font-normal leading-7 text-brand-secondary"
    role="heading"
    aria-level="3"
    [attr.id]="id()">
    {{ label() }}
  </p>
}
